<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, Disclosure, DisclosureButton, DisclosurePanel, Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import moment from 'moment';
import { ref, inject } from 'vue';
import Header from '@/Components/Header.vue';
import Footer from '@/Components/Footer.vue';
import { Switch } from '@headlessui/vue';

const openingTimes = [
    {
        day: 1,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 2,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 3,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 4,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 5,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 6,
        open: '09:00',
        close: '17:00'
    }
];

function isOpen() {
    const now = moment();
    const day = now.day();
    const time = now.format('HH:mm');

    const openingTime = openingTimes.find(time => time.day === day);
    if (!openingTime) {
        return false;
    }

    return time >= openingTime.open && time <= openingTime.close;
}

function closeTime() {
    //get the day and get the closing time for this day
    const now = moment();
    const day = now.day();

    const openingTime = openingTimes.find(time => time.day === day);

    return openingTime.close;
}

function openTime() {
    //get the day and get the closing time for this day
    const now = moment();
    const day = now.day();

    const openingTime = openingTimes.find(time => time.day === day);

    if (!openingTime) {
        return 'maandag 09:00';
    }

    return openingTime.open;
}


const showEssential = ref(false)
const showAnalytics = ref(false)
const showCookie = ref(false)
const showCookieSettings = ref(false)
const acceptAnalytics = ref(false)
//check if cookies need to be shown
const $cookies = inject('$cookies');
if ($cookies.get('cookie-consent') === undefined || $cookies.get('cookie-consent') === null) {
    showCookie.value = true
} else {
    showCookie.value = false
}
function acceptCookies() {
    $cookies.set('cookie-consent', 'true', "1y");
    showCookie.value = false
    showCookieSettings.value = false
    if (acceptAnalytics.value) {
        //set cookie that anyalytics are accepted
        $cookies.set('cookie-analytics', 'true', "1y");

        setCookiesAsScripts();
    }
}

function acceptAllCookies() {   
    $cookies.set('cookie-consent', 'true', "1y");

    $cookies.set('cookie-analytics', 'true', "1y");

    setCookiesAsScripts();
    showCookie.value = false
    showCookieSettings.value = false
}

function setCookiesAsScripts() {
    //do cookie consent mode v2
    //set google analytics
    gtag('consent', 'update', {
        'ad_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
        'analytics_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
        'ad_user_data': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
        'ad_personalization': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
    });
}

function checkCookies() {
    //check cookie-anaytics
    if ($cookies.get('cookie-analytics') !== undefined && $cookies.get('cookie-analytics') !== null) {
        setCookiesAsScripts();
    }
}
</script>

<template>
    <Head title="Privacyverklaring | mijnautosnelweg.nl">
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
        <link rel="manifest" href="/site.webmanifest">
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ff5a22">
        <meta name="msapplication-TileColor" content="#ff5a22">
        <meta name="theme-color" content="#ffffff">
        <meta property="og:url" content="https://mas.codespreview.nl">
        <meta property="og:type" content="website">
        <meta property="og:title" content="Verkoop je auto, zonder omwegen | mijnautosnelweg.nl">
        <meta property="og:description" content="Jouw route naar autoverkoop!">
        <meta property="og:image" content="/img/og_image.png">
        <meta name="twitter:card" content="summary_large_image">
        <meta property="twitter:domain" content="mas.codespreview.nl">
        <meta property="twitter:url" content="https://mas.codespreview.nl">
        <meta name="twitter:title" content="Verkoop je auto, zonder omwegen | mijnautosnelweg.nl">
        <meta name="twitter:description" content="Jouw route naar autoverkoop!">
        <meta name="twitter:image" content="/img/og_image.png">
    </Head>

    <Header :isInnerPage="true" />
  
    <div class="relative mt-40">
        <div class="p-4 flex flex-col mt-20 mx-auto max-w-4xl">
            <div class="flex flex-col gap-2 mb-12">
                <h1 class="text-4xl text-royalblue-500 text-balance">Privacyverklaring mijnautosnelweg.nl B.V.</h1>
                <p class="text-base">Welkom bij mijnautosnelweg.nl!</p>
                <p class="text-base">We willen dat je je op je gemak voelt als je onze website bezoekt, en een belangrijk onderdeel daarvan is het respecteren van jouw privacy. Daarom zorgen we ervoor dat jouw gegevens bij ons in goede handen zijn. Lees hieronder hoe we omgaan met jouw persoonlijke gegevens en wat we doen om ze veilig te houden.</p>
            </div>
            <div class="">
                <h2 class="text-2xl text-royalblue-500 font-normal mb-4">Welke gegevens verzamelen we en waarom?</h2>
                <p class="text-base">Wanneer je gebruik maakt van onze diensten of contact met ons opneemt, verzamelen we alleen de informatie die we écht nodig hebben om je goed te kunnen helpen. Denk hierbij aan je naam, e-mailadres en adresgegevens. Dit soort informatie gebruiken we bijvoorbeeld om:</p>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Je te helpen met je aanvragen of vragen.</li>
                    <li>Een overeenkomst te kunnen opstellen als dat nodig is.</li>
                    <li>Te begrijpen welke onderdelen van onze website het best werken, zodat we deze kunnen verbeteren.</li>
                </ul>
                <h2 class="pt-8 text-2xl text-royalblue-500 font-normal mb-4">Cookies, maar dan wel lekkere!</h2>
                <p class="text-base">Onze website maakt gebruik van cookies, maar niet van die om op te eten. Deze kleine, slimme bestandjes helpen ons om de website soepel te laten werken. Ze onthouden bijvoorbeeld dat je al bent ingelogd, of welke auto's je interessant vond, zodat je die niet telkens opnieuw hoeft op te zoeken.</p>
                <p class="text-base mt-4">Er zijn verschillende soorten cookies:</p>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Functionele cookies:</li>
                    <p class="text-base mt-4 ml-6">Zorgen ervoor dat alles goed werkt, bijvoorbeeld dat je niet steeds opnieuw je wachtwoord hoeft in te voeren.</p>
                </ul>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Analytische cookies:</li>
                    <p class="text-base mt-4 ml-6">Hiermee zien we hoe je door de website surft, zodat we weten wat we kunnen verbeteren. Geen zorgen, jouw privacy blijft gewaarborgd.</p>
                </ul>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Advertentie cookies:</li>
                    <p class="text-base mt-4 ml-6">Deze cookies helpen ons relevante advertenties voor jou te tonen. Zo krijg je geen herhaling van dezelfde advertenties, maar alleen datgene wat je echt interesseert.</p>
                </ul>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Social Media cookies:</li>
                    <p class="text-base mt-4 ml-6">Hiermee kun je artikelen delen op je sociale netwerken en zorgen we dat de advertenties aansluiten bij jouw voorkeuren.</p>
                </ul>
                <p class="text-base mt-4">Wil je liever zonder cookies surfen? Geen probleem! Maar let op, de website kan dan misschien niet meer optimaal werken. Hier lees je hoe je cookies kunt uitschakelen: <a href="https://www.consumentenbond.nl/internet-privacy/cookies-verwijderen" target="_blank">https://www.consumentenbond.nl/internet-privacy/cookies-verwijderen</a></p>
                <h2 class="pt-8 text-2xl text-royalblue-500 font-normal mb-4">Jouw gegevens delen? No way!</h2>
                <p class="text-base">Wij delen jouw persoonlijke gegevens niet zomaar met anderen. Echt niet. De enige momenten waarop we jouw informatie delen, is als het écht nodig is. Bijvoorbeeld om een betaling te verwerken, of als de wet het vereist. Je gegevens verkopen? Absoluut niet.</p>
                <h2 class="pt-8 text-2xl text-royalblue-500 font-normal mb-4">Veiligheid voorop!</h2>
                <p class="text-base">We snappen dat jouw privacy belangrijk is. Daarom doen we er alles aan om je gegevens goed te beveiligen. We gebruiken slimme technieken om te zorgen dat niemand zonder toestemming bij jouw gegevens kan.</p>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Hoelang bewaren we jouw gegevens?</li>
                    <p class="text-base mt-4 ml-6">Zodra we je gegevens niet meer nodig hebben voor het doel waarvoor je ze hebt gegeven, verwijderen we ze of maken we ze anoniem. Dit betekent dat we niet langer kunnen zien dat de gegevens bij jou horen. Soms bewaren we ze iets langer, bijvoorbeeld om een klantonderzoek te doen, maar alleen als dat echt nodig is.</p>
                </ul>
                <ul class="list-disc list-inside mt-4 space-y-1.5">
                    <li>Jouw rechten, jouw keuzes.</li>
                    <p class="text-base mt-4 ml-6">Je hebt altijd de controle over jouw gegevens. Wil je weten welke gegevens we van jou hebben? Wil je dat we iets aanpassen of verwijderen? Geen probleem! Je kunt ons op elk moment vragen om inzicht in je gegevens, om ze te corrigeren of om ze te verwijderen.</p>
                </ul>
                <p class="text-base mt-4">We snappen dat jouw privacy belangrijk is. Daarom doen we er alles aan om je gegevens goed te beveiligen. We gebruiken slimme technieken om te zorgen dat niemand zonder toestemming bij jouw gegevens kan.</p>
            </div>
        </div>
    </div>

    <div class="p-4 relative">
        <div class="max-w-4xl mx-auto pt-12">
            <div class="flex flex-col gap-8 bg-white rounded-2xl p-8 shadow-2xl shadow-deepblue/40">
                <div class="flex flex-col gap-6">
                    <h2 class="text-lg sm:text-xl md:text-2xl text-royalblue-500 font-bold mb-8">Wilt u ons spreken, is er iets onduidelijk of hebt u een andere vraag? </h2>
                    <p class="mb-2 pb-2 border-b border-royalblue-500/20 text-xl">mijnautosnelweg.nl B.V.</p>
                    <div class="grid grid-cols-1 md:grid-cols-2">
                        <p class="md:order-1 mb-2">Slot 6, 7608 ND Almelo</p>
                        <p class="md:order-3 mb-2">KvK-nummer: 94764352</p>
                        <p class="md:order-2 mb-2">E-mail: hallo@mijnautosnelweg.nl</p>
                        <p class="md:order-4 mb-2">Telefoon: 085-0477766</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute h-full w-full inset-0 -z-40 flex flex-col">
            <div class="h-fit flex grow w-full bg-white"></div>
            <div class="h-4/5 w-full bg-gradient-to-b from-transparent to-royalblue-500 via-lessbrightorange via-35%"></div>
        </div>
    </div>

    <!-- Use the Footer component -->
    <Footer />


    <div v-if="showCookie" class="fixed bottom-0 left-0 right-0 border-t-2 border-royalblue-500 bg-white w-full flex flex-col md:flex-row items-center justify-between gap-4 px-6 py-3">
        <p class="text-balance text-center md:text-left">Mijnautosnelweg maakt gebruik van cookies om onze website te verbeteren, maar alleen met jouw toestemming. Bij instellingen lees je meer over hoe het werkt.</p>
        <div class="flex flex-row gap-4 items-center">
            <a @click="showCookieSettings = true;" class="group transition-all duration-300 ease-in-out inline-flex items-center border-b-2 border-transparent pt-1 text-base font-base  text-royalblue-500 hover:text-royalblue-500/80">
                <span class="hover:cursor-pointer bg-left-bottom bg-gradient-to-r from-brightorange to-brightorange bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                    Instellingen
                </span>
            </a>
            <a @click="acceptAllCookies" class="primary-btn hover:cursor-pointer">Accepteren</a>
        </div>
    </div>

    <TransitionRoot as="template" :show="showCookieSettings">
        <Dialog as="div" class="relative z-50">
            <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-clip rounded-lg bg-white border shadow-deepblue/40 shadow-3xl px-4 pb-4 pt-5 text-left transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                            <div
                                class="flex flex-col gap-4 p-4 overflow-y-auto  max-h-[512px] sm:max-h-[628px] md:max-h-[745px]">
                                                <div class="flex justify-between items-center mb-4 rounded-t sm:mb-5">
                                    <DialogTitle>
                                        <img class="h-8 w-auto mt-2" src="/public/img/logo_full.svg"
                                            alt="mijnautosnelweg" />
                                    </DialogTitle>
                                </div>
                                <form action="#">
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Cookie instellingen
                                        </h4>
                                        <p class="block mb-4 text-sm text-gray-900 ">Om deze Diensten te gebruiken,
                                            hebben we uw toestemming nodig. Door op “Alles accepteren” te klikken,
                                            verklaart u uw toestemming voor het gebruik van alle Diensten. U kunt ook uw
                                            toestemming verklaren door individueel op de schuifregelaars voor elke
                                            categorie cookies te klikken en opslaan.</p>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Essentiele cookies
                                        </h4>
                                        <p class="block mb-4 text-sm text-gray-900">Essentiële cookies worden gebruikt om de basisfunctionaliteiten van de website te waarborgen, zoals navigatie en toegang tot beveiligde gedeelten van de website. Zonder deze cookies kan de website niet naar behoren functioneren.</p>                                        <button v-if="!showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showEssential" class="transition-all duration-300 ease-in-out">
                                            <div class="mt-10 ring-1 ring-gray-300 mx-0 rounded-lg overflow-hidden">
                                                <table class="min-w-full divide-y divide-gray-300 border-b">
                                                    <thead class="bg-royalblue-500/5">
                                                        <tr>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Naam
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Expiration
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Purpose
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="divide-y">
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                mijnautosnelweg_session
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt dat je dat data veilig verstuurd word
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                XSRF-TOKEN
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt voor een naadloze ervaring
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                fontsCssCache
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                7 dagen
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Geeft aan of de fonts al ingeladen zijn
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <div class="relative flex justify-between">
                                            <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Analytics
                                                cookies</h4>
                                            <Switch v-model="acceptAnalytics"
                                                class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none">
                                                <span class="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                    class="pointer-events-none absolute h-full w-full rounded-md" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'bg-brightorange' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                                            </Switch>
                                        </div>
                                        <p class="block mb-4 text-sm text-gray-900">Analytics cookies worden gebruikt om informatie te verzamelen over hoe bezoekers onze website gebruiken. Deze informatie helpt ons om de website te verbeteren door inzicht te krijgen in het gebruik en de prestaties van de site.</p>                                        <button v-if="!showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showAnalytics" class="transition-all duration-300 ease-in-out">
                                            <table class="mt-4 mb-4 w-full border bg-white rounded-xl overflow-hidden">
                                                <thead class="border-b bg-royalblue-500/5">
                                                    <tr>
                                                        <th class="px-4 py-2 text-left">Naam</th>
                                                        <th class="px-4 py-2 text-left">Expiration</th>
                                                        <th class="px-4 py-2 text-left">Purpose</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga_KQVNRHT4TX</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                                <div class="mt-4 flex justify-end items-center space-x-6">
                                    <button @click="acceptCookies" type="button" class="group transition-all duration-300 ease-in-out inline-flex items-center border-b-2 border-transparent pt-1 text-base font-semibold  text-royalblue-500 hover:text-royalblue-500/80">
                                        <span class="bg-left-bottom bg-gradient-to-r from-brightorange to-brightorange bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                                            Opslaan en verder
                                        </span>
                                    </button>
                                    <button type="button"
                                        class="inline-flex w-auto justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                                        @click="acceptAllCookies">Alles accepteren</button>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
